export const CORE_CHAIN = 43114;
export const OLD_CHAIN = 1666600000;
export const DEV_MODE = process.env.NODE_ENV === 'development';
export const MIN_CACHE_TIME_MS = 59000;
export const DEV_TEST_ADDRESS = DEV_MODE ? '' : ''
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
